import React from "react";
import "./Donation.css";
import qrImage from "../images/img1.jpg";

const Donation = () => {
  return (
    <section className="donation-section">

      <h1 className="donation-main-title">“देणगी”</h1>

      <div className="donation-container">

        <p className="donation-intro">
          तुमची उदारता आपल्या समाजात लक्षणीय बदल घडवू शकते. आमच्या सार्वजनिक 
          वाचनालयाला देणगी देऊन, तुम्ही शिक्षण, संस्कृती आणि आपल्या समाजाच्या 
          भविष्यासाठी गुंतवणूक करत आहात.
        </p>

        <p>
          ह्या बरोबर शैक्षणिक व सांस्कृतिक कार्यक्रम समाजासाठी विनामूल्य 
          केले जातात. आपल्या देणगीतून आम्हाला पुस्तकांचा आणि डिजिटल साहित्य 
          संग्रह राखण्यात आणि वाढवण्यासाठी मदत होते.
        </p>

        <p>
          तुमच्या पाठिंब्याने, आपल्या समाजातील सदस्यांचे जीवन समृद्ध करणाऱ्या 
          अधिक कार्यशाळा, साक्षरता कार्यक्रम आणि सांस्कृतिक कार्यक्रम देऊ शकतो.
        </p>

        {/* 🔥 NEW PARAGRAPH 1 */}
        <p>
          आपल्या देणगीतून ग्रामीण भागातील विद्यार्थ्यांना दर्जेदार अभ्यास साहित्य,
          स्पर्धा परीक्षांसाठी आवश्यक पुस्तके आणि डिजिटल सुविधा उपलब्ध करून देता येतात.
          तुमचा प्रत्येक हातभार ज्ञानाचा दीप प्रज्वलित करण्यास मदत करतो.
        </p>

        {/* 🔥 NEW PARAGRAPH 2 */}
        <p>
          ग्रंथालय हे केवळ पुस्तकांचे भांडार नसून समाज घडविण्याचे केंद्र आहे.
          आपल्या सहकार्यामुळे आम्ही अधिक उपक्रम, व्याख्यानमाला आणि
          शैक्षणिक संधी समाजापर्यंत पोहोचवू शकतो.
        </p>

        <div className="donation-box">
          <h2>देणगीरुपी निधीचा वापर :</h2>
          <ul className="no-dots">
            <li>संग्रह वाढवणे आणि अध्यावत करणे – पुस्तके, ई-पुस्तके व माहिती स्त्रोत वाढवणे.</li>
            <li>शैक्षणिक कार्यक्रमांचे आयोजन – कार्यशाळा, साक्षरता उपक्रम व सामुदायिक कार्यक्रम.</li>
            <li>सुविधा आणि तंत्रज्ञान अपग्रेड – आधुनिक तंत्रज्ञानासह सुविधा उपलब्ध करणे.</li>
            <li>सुसंस्कृत समाज घडवणे – साक्षरता व सांस्कृतिक समृद्धीला प्रोत्साहन.</li>
          </ul>
        </div>

        <div className="donation-box">
          <h2>कर लाभ :</h2>
          <p>
            आमचे ग्रंथालय वर्ग ‘ड’ मध्ये नोंदणीकृत असून 80G आणि 12AA प्रमाणपत्र प्राप्त आहे.
            देणगी देणाऱ्या व्यक्तींना आयकर कायद्यानुसार कर सवलत मिळेल.
          </p>
        </div>

        {/* BANK DETAILS */}
        <div className="bank-details">
          <h2>बँक तपशील :</h2>

          <div className="bank-content">

            <div className="bank-info">
              <p><strong>बँकेचे नाव :</strong> Bank Of India, Kodoli</p>
              <p><strong>खाते क्रमांक :</strong> 092710100011062</p>
              <p><strong>IFSC कोड :</strong> BKID0000927</p>
              <p><strong>पत्ता :</strong> Kodoli, Tal. Panhala, Dist. Kolhapur</p>
            </div>

            <div className="qr-section">
              <img src={qrImage} alt="QR Code" />
              <p>ऑनलाईन पेमेंट करण्यासाठी हा कोड स्कॅन करा</p>
            </div>

          </div>
        </div>

      </div>
    </section>
  );
};

export default Donation;